<template>
    <a :href="card.WebsiteLink" target="_blank" class="card mt-2">
        <div v-lazy:background-image="backgroundImage" class="card__overlay">
            <img v-lazy="card.Logo" :alt="card.Name" :title="card.Name" />
        </div>
        <span class="color--black">{{ card.City }}</span>
        <h3 class="color--blue-7">{{ card.Name }}</h3>
    </a>
</template>

<script>
export default {
    props: {
        card: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        backgroundImage: function() {
            if (typeof this.card.image !== 'undefined') {
                return this.card.image;
            }
            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    flex: 1 1 auto;
    position: relative;
    padding: 0 35px 30px 35px;
    display: block;
    transition: 0.25s transform ease-in-out;
    backface-visibility: hidden;

    @include media-breakpoint-up(md) {
        padding: 0;
    }

    &:hover {
        transform: scale(1.05);
    }
}

.card img {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    width: 180px;
    z-index: 10;
    pointer-events: none;
}

.card__overlay {
    background-image: url(/Content/img/kijken-1920.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 375px;
    position: relative;
    display: block;
    text-decoration: none;
    margin-bottom: 20px;
    border-radius: 7px;
    overflow: hidden;

    &:before {
        content: '';
        background-color: rgba(65, 65, 65, 0.3);
        height: 100%;
        width: 100%;
        position: absolute;
    }
}
</style>
